import PhoneSvg from "../phone.svg";
import styles from "./phone.module.scss";

const Phone = () => {
  return (
    <div className={styles.phone}>
      <PhoneSvg />
    </div>
  );
};

export default Phone;
